export function TargetAudience() {
    const badges = [
        "🍕 Camion pizza", "🚚 Food truck", "🥙 Kebab / Snack", "🥪 Sandwicherie",
        "🍔 Burger shop", "🥗 Vente à emporter", "🍜 Petite restauration",
    ];
    return (
        <section className="py-12 px-6 bg-slate-50" id="pour-qui">
            <div className="text-center mb-4">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-slate-900 leading-[1.2] tracking-tight mb-4">
                    Conçu pour les entrepreneurs<br />de la restauration rapide.
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-500 max-w-[680px] mx-auto mb-12 leading-relaxed">
                    Que vous soyez mobile ou fixe, cette solution s'adapte à votre activité.
                </p>
            </div>
            <div className="flex flex-wrap gap-3 justify-center">
                {badges.map(b => (
                    <div key={b} className="inline-flex items-center gap-2 px-5 py-2.5 bg-white border border-slate-200 rounded-full text-[0.95rem] font-semibold text-slate-900 shadow-sm">
                        {b}
                    </div>
                ))}
            </div>
        </section>
    );
}
